export default __webpack_public_path__ + "static/media/peer-to-machine-chatbot.7d35f81a.png";